import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Context';
import { AuthContextApi } from '../../../Context/api';
import {
    InformationCircleIcon,
    MagnifyingGlassIcon,
    XMarkIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    UserIcon,
    ChartBarIcon,
    PlusIcon,
    PencilIcon,
    EyeIcon,
    TrashIcon,
    LockClosedIcon,
    LockOpenIcon,
    EnvelopeIcon,
    CalendarIcon,
    CheckCircleIcon,
    XCircleIcon,
    ArrowLeftIcon
} from '@heroicons/react/24/outline'
import Table from '../../../Components/Table/Usuarios';
import NavMenu from '../../../Components/NavMenu/Usuarios';
import Modal from '../../../Components/Modal/Usuarios';
import { toast } from 'react-toastify';


const Usuarios = () => {

    const { states, setters } = useContext(AuthContext)
    const { checkLogin,
        getUsuariosDataSistema,
        getUsuarios,
        getUsuariosQuery,
        putRoleUsuarios,
        blockUnlockUsuarios,
        forgotPass,
        deleteUsuarios,
        postUsuarios } = useContext(AuthContextApi)
    const navigate = useNavigate()
    const [query, setQuery] = useState('')

    // Estados locais para busca dinâmica e ordenação
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedFilterField, setSelectedFilterField] = useState('email')
    const [selectedSortField, setSelectedSortField] = useState('data_criacao')
    const [sortDirection, setSortDirection] = useState('desc')
    const [recordsPerPage, setRecordsPerPage] = useState(10)

    // Opções de filtro
    const filterOptions = [
        { value: 'email', label: 'E-mail' }
    ]

    // Opções de ordenação
    const sortOptions = [
        { value: 'data_atualizacao', label: 'Data de Atualização' },
        { value: 'data_criacao', label: 'Data de Criação' },
        { value: 'email', label: 'E-mail' },
        { value: 'role', label: 'Permissão' }
    ]



    const primeiroLoad = async () => {
        await getUsuariosDataSistema()
        const params = new URLSearchParams({
            page: 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: selectedFilterField,
            search: ''
        })
        await getUsuarios(params.toString())
        await checkLogin()
    }

    const loadUsuarios = async () => {
        const params = new URLSearchParams({
            page: states.page || 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: selectedFilterField,
            search: searchTerm
        })
        await getUsuarios(params.toString())
    }


    const next = async () => {
        setters.setPage(states.page + 1)
    }

    const previous = async () => {
        if (states.page > 0) {
            setters.setPage(states.page - 1)
        }
    }

    const search = async () => {
        setters.setPage(0)
        const params = new URLSearchParams({
            page: 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: selectedFilterField,
            search: searchTerm
        })
        await getUsuarios(params.toString())
    }

    const clear = async () => {
        setters.setPage(0)
        setSearchTerm('')
        setSelectedFilterField('email')
        setSelectedSortField('data_criacao')
        setSortDirection('desc')
        setRecordsPerPage(10)
        const params = new URLSearchParams({
            page: 0,
            per_page: 10,
            sort: 'data_criacao',
            sort_dir: 'desc',
            filter: 'email',
            search: ''
        })
        await getUsuarios(params.toString())
    }

    const addUsuarios = () => {
        setters.setIsEdit(false)
        setters.setUsuarios({})
        setters.setModalUsuarios(true)
    }

    // Função para retornar ao painel de cadastros
    const returnToCadastros = () => {
        navigate('/cadastros')
    }

    const editUsuarios = (data) => {
        setters.setIsEdit(true)
        setters.setUsuarios(data)
        setters.setModalUsuarios(true)
    }

    const actionModal = async (data) => {
        setters.setModalUsuarios(false)
        if (states.isEdit) {
            await putRoleUsuarios(data)
        } else {
            await postUsuarios(data)
        }
    }

    const blockUnlock = async (data) => {
        setters.setModalUsuarios(false)
        setters.setModalMsg(true)
        setters.setPerigoModalMsg(data.bloqueado)
        const msg = data.bloqueado ? 'desbloquear' : 'bloquear'
        setters.setMsgModalMsg(`Deseja mesmo ${msg} o usuário ${data.email}?`)
        setters.setDescModalMsg(`Após a confirmação o usuário será ${data.bloqueado ? 'bloqueado' : 'desbloqueado'}`)
        setters.setTitleButtonModalMsg('Confirmar')
        setters.setFunctionModalMsg(() => async () => {
            await blockUnlockUsuarios(data.id, data.bloqueado)
            setters.setModalMsg(false)
        })
    }

    const actionDeleteUser = async (data) => {
        setters.setModalMsg(true)
        setters.setPerigoModalMsg(true)
        setters.setMsgModalMsg(`Deseja mesmo excluir o usuário ${data.email}?`)
        setters.setDescModalMsg(`Após a confirmação o usuário será excluído`)
        setters.setTitleButtonModalMsg('Confirmar')
        setters.setFunctionModalMsg(() => async () => {
            await deleteUsuarios(data.id)
            setters.setModalMsg(false)
        })
    }

    const generateForgot = async (data) => {
        setters.setModalUsuarios(false)
        setters.setModalMsg(true)
        setters.setPerigoModalMsg(true)
        setters.setMsgModalMsg(`Deseja mesmo gerar link de recuperação para o usuário ${data.email}?`)
        setters.setDescModalMsg(`Após a confirmação o usuário receberá um e-mail com o link de recuperação`)
        setters.setTitleButtonModalMsg('Confirmar')
        setters.setFunctionModalMsg(() => async () => {
            const response = await forgotPass({ email: data.email })
            if (response === false) {
                toast.error('Erro ao gerar link de recuperação')
            } else {
                toast.success('Link de recuperação gerado com sucesso')
            }
            setters.setModalMsg(false)
        })
    }



    useEffect(() => {
        primeiroLoad()

        return () => {
            setQuery('')
            setters.setDataEstatisticaUsuarios([])
            setters.setDataUsuarios([])
            setters.setUsuarios({})
            setters.setOffsetUsuarios(0)
            setters.setLimiteBuscaUsuarios(false)
            setters.setModalUsuarios(false)
        }

    }, [])



    useEffect(() => {
        loadUsuarios()
    }, [states.page, sortDirection, selectedSortField, selectedFilterField, recordsPerPage])

    const headers = ['', 'E-mail', 'E-mail verificado', 'Bloqueado', 'Permissão', 'Data de Criação', 'Data de Atualização']

    return (
        <>
            {/* Header da Página */}
            <div className="bg-white border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <button
                                onClick={returnToCadastros}
                                className="mr-4 p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                                title="Voltar ao painel de cadastros"
                            >
                                <ArrowLeftIcon className="w-5 h-5 text-gray-600" />
                            </button>
                            <div className="p-2 rounded-lg bg-indigo-100 mr-3">
                                <UserIcon className="w-6 h-6 text-indigo-600" />
                            </div>
                            <div>
                                <h1 className="text-2xl font-semibold text-gray-900">
                                    Usuários
                                </h1>
                                <p className="text-sm text-gray-600">
                                    Gerencie usuários e permissões do sistema
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={addUsuarios}
                            className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-200"
                        >
                            <PlusIcon className="w-4 h-4 mr-2" />
                            Adicionar Usuário
                        </button>
                    </div>
                </div>
            </div>

            {/* Conteúdo Principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Cards de Estatísticas - Design Artístico */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                    {states.dataEstatisticaUsuarios?.length > 0 && states.dataEstatisticaUsuarios.map((card, index) => (
                        <div key={card.title} className="relative bg-gradient-to-br from-indigo-50 via-white to-blue-50/30 backdrop-blur-sm rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden">
                            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-blue-500/5"></div>
                            <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-indigo-400/10 to-blue-400/10 rounded-full -translate-y-12 translate-x-12"></div>
                            <div className="relative p-6">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="p-3 rounded-2xl bg-gradient-to-r from-indigo-500 via-blue-600 to-blue-700 shadow-lg">
                                        <ChartBarIcon className="w-6 h-6 text-white" />
                                    </div>
                                    <div className="text-right">
                                        <div className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-blue-800 bg-clip-text text-transparent">
                                            {card.value}
                                        </div>
                                    </div>
                                </div>
                                <h3 className="text-lg font-semibold bg-gradient-to-r from-gray-900 via-indigo-800 to-blue-700 bg-clip-text text-transparent">
                                    {card.title}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Formulário de Busca - Design Artístico */}
                <div className="relative bg-gradient-to-br from-indigo-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm rounded-3xl shadow-lg border border-indigo-100/50 mb-8 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-blue-500/5"></div>
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-400/10 to-blue-400/10 rounded-full -translate-y-16 translate-x-16"></div>
                    <div className="relative p-6">
                        <div className="flex items-center mb-4">
                            <div className="p-3 rounded-2xl bg-gradient-to-r from-indigo-500 via-blue-600 to-blue-600 shadow-lg mr-4">
                                <MagnifyingGlassIcon className="w-6 h-6 text-white" />
                            </div>
                            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-blue-800 bg-clip-text text-transparent">
                                Pesquisa Avançada
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Termo de Busca</label>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            search()
                                        }
                                    }}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Digite para buscar..."
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Campo de Filtro</label>
                                <select
                                    value={selectedFilterField}
                                    onChange={(e) => setSelectedFilterField(e.target.value)}
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    {filterOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Campo de Ordenação</label>
                                <select
                                    value={selectedSortField}
                                    onChange={(e) => setSelectedSortField(e.target.value)}
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    {sortOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Direção da Ordenação</label>
                                <select
                                    value={sortDirection}
                                    onChange={(e) => setSortDirection(e.target.value)}
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    <option value="asc">Crescente (A-Z)</option>
                                    <option value="desc">Decrescente (Z-A)</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Registros por Página</label>
                                <select
                                    value={recordsPerPage}
                                    onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    <option value={5}>5 registros</option>
                                    <option value={10}>10 registros</option>
                                    <option value={20}>20 registros</option>
                                    <option value={50}>50 registros</option>
                                </select>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={search}
                                className="flex-1 group relative inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 via-blue-700 to-blue-700 hover:from-indigo-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <MagnifyingGlassIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                    <span>Buscar</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>

                            <button
                                onClick={clear}
                                className="flex-1 group relative inline-flex items-center justify-center px-6 py-3 border border-indigo-300 rounded-2xl shadow-lg text-sm font-semibold text-indigo-700 bg-gradient-to-r from-indigo-50 to-indigo-50 hover:from-indigo-100 hover:to-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <XMarkIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                    <span>Limpar</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
                {/* Cards de Usuários - Design Artístico */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                    {states.loading ? (
                        <div className="col-span-full flex items-center justify-center py-12">
                            <div className="text-center">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
                                <p className="mt-4 text-gray-600">Carregando usuários...</p>
                            </div>
                        </div>
                    ) : states.dataUsuarios && states.dataUsuarios.length > 0 ? (
                        states.dataUsuarios.map((usuario) => (
                            <div
                                key={usuario.id}
                                className="relative bg-gradient-to-br from-indigo-50 via-white to-blue-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-indigo-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden group"
                            >
                                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-blue-500/5"></div>
                                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-indigo-400/10 to-blue-400/10 rounded-full -translate-y-12 translate-x-12"></div>

                                {/* Badge de Status */}
                                <div className="absolute top-4 right-4">
                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium text-white ${usuario.bloqueado ? 'bg-red-500' : 'bg-green-500'
                                        }`}>
                                        {usuario.bloqueado ? (
                                            <>
                                                <LockClosedIcon className="w-3 h-3 mr-1" />
                                                Bloqueado
                                            </>
                                        ) : (
                                            <>
                                                <LockOpenIcon className="w-3 h-3 mr-1" />
                                                Ativo
                                            </>
                                        )}
                                    </span>
                                </div>

                                <div className="relative p-5">
                                    {/* Header do Card */}
                                    <div className="flex items-center mb-3">
                                        <div className="p-2 rounded-xl bg-gradient-to-r from-indigo-500 via-blue-600 to-blue-700 shadow-lg mr-3 flex-shrink-0">
                                            <UserIcon className="w-5 h-5 text-white" />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <h3 className="text-sm font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-blue-700 bg-clip-text text-transparent truncate">
                                                {usuario.email}
                                            </h3>
                                            <p className="text-xs text-gray-600 mt-1 truncate">
                                                {usuario.role || 'Sem permissão definida'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Informações do Usuário */}
                                    <div className="mb-3 p-3 bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl border border-gray-100">
                                        <div className="space-y-2">
                                            <div className="flex items-center">
                                                <div className="p-1.5 rounded-lg bg-green-100 text-green-700 mr-2">
                                                    <EnvelopeIcon className="w-3 h-3" />
                                                </div>
                                                <div>
                                                    <p className="text-xs font-medium text-gray-700">E-mail Verificado</p>
                                                    <p className="text-xs text-gray-600">
                                                        {usuario.email_verificado ? (
                                                            <span className="text-green-600 flex items-center">
                                                                <CheckCircleIcon className="w-3 h-3 mr-1" />
                                                                Verificado
                                                            </span>
                                                        ) : (
                                                            <span className="text-red-600 flex items-center">
                                                                <XCircleIcon className="w-3 h-3 mr-1" />
                                                                Não verificado
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center">
                                                <div className="p-1.5 rounded-lg bg-blue-100 text-blue-700 mr-2">
                                                    <CalendarIcon className="w-3 h-3" />
                                                </div>
                                                <div>
                                                    <p className="text-xs font-medium text-gray-700">Criado em</p>
                                                    <p className="text-xs text-gray-600">
                                                        {new Date(usuario.data_criacao).toLocaleDateString('pt-BR')}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Botões de Ação */}
                                    <div className="flex items-center justify-between">
                                        <div className="flex space-x-2">
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    editUsuarios(usuario)
                                                }}
                                                className="p-1.5 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition-colors duration-200"
                                                title="Editar"
                                            >
                                                <PencilIcon className="w-3 h-3" />
                                            </button>

                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    blockUnlock(usuario)
                                                }}
                                                className={`p-1.5 rounded-full transition-colors duration-200 ${usuario.bloqueado
                                                    ? 'bg-green-100 text-green-700 hover:bg-green-200'
                                                    : 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
                                                    }`}
                                                title={usuario.bloqueado ? 'Desbloquear' : 'Bloquear'}
                                            >
                                                {usuario.bloqueado ? (
                                                    <LockOpenIcon className="w-3 h-3" />
                                                ) : (
                                                    <LockClosedIcon className="w-3 h-3" />
                                                )}
                                            </button>

                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    generateForgot(usuario)
                                                }}
                                                className="p-1.5 bg-purple-100 text-purple-700 rounded-full hover:bg-purple-200 transition-colors duration-200"
                                                title="Recuperar Senha"
                                            >
                                                <EnvelopeIcon className="w-3 h-3" />
                                            </button>

                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    actionDeleteUser(usuario)
                                                }}
                                                className="p-1.5 bg-red-100 text-red-700 rounded-full hover:bg-red-200 transition-colors duration-200"
                                                title="Excluir"
                                            >
                                                <TrashIcon className="w-3 h-3" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-span-full text-center py-12">
                            <div className="p-4 rounded-3xl bg-gradient-to-r from-gray-50 to-blue-50 border border-gray-200">
                                <UserIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhum usuário encontrado</h3>
                                <p className="text-gray-600 mb-4">Não há usuários cadastrados ou que correspondam aos critérios de busca.</p>
                                <button
                                    onClick={addUsuarios}
                                    className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-indigo-600 to-blue-600 text-white rounded-xl hover:from-indigo-700 hover:to-blue-700 transition-all duration-300"
                                >
                                    <PlusIcon className="w-4 h-4 mr-2" />
                                    Adicionar Usuário
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* Paginação */}
                {states.dataUsuarios && states.dataUsuarios.length > 0 && (
                    <div className="flex items-center justify-between bg-white rounded-2xl shadow-lg border border-gray-200 p-4">
                        <div className="flex items-center text-sm text-gray-700">
                            <span>Página {states.page + 1} - {states.dataUsuarios.length} usuários</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <button
                                onClick={previous}
                                disabled={states.page === 0}
                                className="flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <ChevronLeftIcon className="w-4 h-4 mr-1" />
                                Anterior
                            </button>
                            <button
                                onClick={next}
                                disabled={states.dataUsuarios.length < recordsPerPage}
                                className="flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Próximo
                                <ChevronRightIcon className="w-4 h-4 ml-1" />
                            </button>
                        </div>
                    </div>
                )}

            </div>
            <Modal states={states} setters={setters} action={actionModal} />
        </>
    )

}



export default Usuarios;